import React, { useEffect, useState } from "react";
import {
  Badge,
  Container,
  createStyles,
  SimpleGrid,
  Box,
  Textarea,
  Select,
  Title,
  Indicator,
  Flex,
  Button,
  Text,
  Skeleton,
  TextInput,
  Grid,
} from "@mantine/core";
import TopBar from "../../../components/Topbar";
import AccordionCheck from "../../../components/AccordionCheck";
import { useLocation, useNavigate } from "react-router-dom";
// import moment from "moment";
import moment from "moment-timezone";
import { decrypt } from "../../../utils";
import { useSelector } from "react-redux";
import PreviousNotesComp from "../../../components/TaskTable/PreviousNotesComp";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { CommentDrawer } from "./CommentDrawer";
import { getAllSignatures } from "../../../services/signature";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { DateInput, TimeInput } from "@mantine/dates";
import { isCommunityIntegration, levelOfNeedOptions } from "./AddTask";
import { taskAdlHiddenFields } from ".";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
    backgroundColor: "var(--app-bg)",
    height: "100vh",
  },
  container: {
    borderRadius: "15px",
  },
  mainContainer: {
    padding: "40px 10px 10px 10px",
  },
  topContainer: {
    padding: "10px 20px 30px 8px",
  },
  checkBoxParent: {
    borderRadius: "15px",
    backgroundColor: "var(--app-surface)",
    marginBottom: "20px",
  },
  taskContainer: {
    backgroundColor: "var(--app-surface)",
    borderRadius: "15px",
    padding: "10px 10px 10px 10px",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  mainHeading: {
    margin: "0",
  },
  draft: {
    p: {
      margin: "0",
      border: "1px solid #fab005",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "#fab005",
    },
  },
  completed: {
    p: {
      margin: "0",
      border: "1px solid green",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "green",
    },
  },
  expired: {
    p: {
      margin: "0",
      border: "1px solid red",
      padding: "2px 8px",
      borderRadius: "4px",
      color: "red",
    },
  },
  detail: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  detail: {
    span: {
      color: "var(--app-text-muted)",
    },
  },
  detail: {
    p: {
      margin: "0",
    },
  },
  info: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  info: {
    p: {
      margin: "0",
      textAlign: "center",
    },
  },
  btnFlex: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "20px 0",
    gap: "20px",
  },
  divGap: {
    margin: "20px 0",
    alignItems: "center",
  },
  checkBoxContainer: {
    "@media (min-width:992px)": {
      padding: "0 140px",
    },
  },
  commentBtnStyle: {
    boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    backgroundColor: "#F4F3FF",
    color: "#6C63FF",
  },
  commentFlex: {
    "@media (max-width:600px)": {
      marginTop: "20px",
    },
  },
  signatureImg: {
    width: 250,
    height: "auto",
  },
}));
const ViewTask = () => {
  const { classes } = useStyles();
  const isMoobileScreen = useMediaQuery("(max-width: 600px)");
  const isTabletScreen = useMediaQuery("(max-width: 1030px)");
  const { state } = useLocation();
  // navigate(-1) restores whatever location.state the Client page last had,
  // which usually doesn't include tab: "tasks" (e.g. arriving via a client
  // row click), so it snaps back to the default "profile" tab instead of
  // Tasks. Navigate explicitly with tab: "tasks" instead.
  const goBackToClientTasksTab = () => {
    navigate("/home/client", {
      state: { clientId: state?.client?.id, tab: "tasks" },
    });
  };
  console.log("🚀 ~ ViewTask ~ state:", state);
  const [opened, { open, close }] = useDisclosure(false);
  const [checks, setChecks] = useState([]);
  const [comments, setComments] = useState([]);
  const [hasEnded, setHasEnded] = useState(false);
  const [activePlan, setActivePlan] = useState(null);

  const { allPlans } = useSelector((state) => state?.supportPlan);
  const navigate = useNavigate();
  const { allPatients } = useSelector((state) => state?.patient);
  const { allFacilities } = useSelector((state) => state?.facility);
  const { profile } = useSelector((state) => state.profile);
  let userType = profile?.user?.type;
  const taskStatus = state?.status;
  const { allSignature } = useSelector((state) => state?.signature);
  const staffSignature = allSignature?.find(
    ({ staff, admin }) =>
      (staff && staff?.id === state?.selectedShift?.staff?.id) ||
      (admin && admin?.id === state?.selectedShift?.staff?.id),
  );

  const isIndividualizedSkillsType =
    state?.taskType?.name === "Individualized Skills and Socialization Log";

  async function fetchActivePlan(clientId, facilityId) {
    if (state?.taskType?.name === "Activities of Daily Living") {
      let activePlan = allPlans?.find((v) => {
        const match = v?.client?._id === clientId; // String comparison
        const facMatch = v?.facility?._id === facilityId; // String comparison
        return (
          match &&
          facMatch &&
          v?.status === "active" &&
          v?.isActive === true &&
          v?.deleted !== true &&
          v?.servicePlanData?.activitiesOfDailyLiving
        );
      })?.servicePlanData;

      setActivePlan(activePlan);
      return activePlan;
    } else {
      return null;
    }
  }

  useEffect(() => {
    getAllSignatures();
  }, []);

  useEffect(() => {
    const initializeTask = async () => {
      let fieldIds = state?.fieldsDone?.map((item) => {
        return {
          field: item?.field?._id,
          staff: item?.staff?._id,
        };
      });
      setChecks(fieldIds);
      setComments(state?.comments);
      setHasEnded(taskStatus == "completed" ? true : false);

      if (state.client.id && state?.facility?.id) {
        await fetchActivePlan(state.client.id, state.facility.id);
      }
    };

    if (state) {
      initializeTask();
    }
  }, [state]);

  const AuctionTimer = () => {
    const [remainingTime, setRemainingTime] = useState("");

    useEffect(() => {
      let interval;
      interval = setInterval(() => {
        // const now = moment();
        // const end = moment(state?.taskEndAt);

        const now = moment.tz(moment(), profile?.user?.timeZone);
        const end = moment.tz(
          moment(state?.taskEndAt),
          profile?.user?.timeZone,
        );

        const duration = moment.duration(end.diff(now));

        // const duration = moment.duration(end.diff(now));
        if (duration.asSeconds() <= 0) {
          clearInterval(interval);
          setRemainingTime("Task Ended!");
          // setHasEnded(true);
        } else {
          const days = Math.floor(duration.asDays());
          const hours = String(duration.hours()).padStart(2, "0");
          const minutes = String(duration.minutes()).padStart(2, "0");
          const seconds = String(duration.seconds()).padStart(2, "0");
          setRemainingTime(
            days === 0
              ? `${hours}h ${minutes}m ${seconds}s`
              : `${days}d ${hours}h ${minutes}m ${seconds}s`,
          );
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, [state?.taskEndAt]);

    return (
      <>
        <div style={{ minWidth: "130px" }}>
          <p
            style={{
              textTransform:
                remainingTime === "Task Ended!" ? "initial" : "lowercase",
              fontSize: remainingTime === "Task Ended!" ? "16px" : "18px",
            }}
          >
            {remainingTime || "-"}
          </p>
        </div>
      </>
    );
  };

  return (
    <Container fluid className={classes.content} px={0}>
      <AppNavbar title={"Task"} profile={profile} />
      <Flex
        align="center"
        gap={5}
        mt={5}
        // onClick={() => navigate("/home/tasks")}
          onClick={() =>
          state?.isClientPage === true
            ? goBackToClientTasksTab()
            : navigate("/home/tasks")
        }
        style={{ cursor: "pointer", width: "fit-content" }}
      >
        <MdKeyboardArrowLeft size={30} />
        <Text fw={400} fz={14} c={"var(--app-text)"} ff={"Inter"}>
          Back
        </Text>
      </Flex>
      <Title order={3} mt={5} ml={10}>
        View Task
      </Title>
      <Box className={classes.topContainer}>
        <Box className={`${classes.taskContainer}`}>
          <div className={classes.flex}>
            <h2 className={classes.mainHeading}>
              {state?.taskType?.name || ""}
            </h2>
            {/* <Text c={"dimmed"}>
              {state?.dateTime &&
                moment(
                  state?.dateTime ? state?.dateTime : state?.createdAt
                ).format("dddd, MMMM Do, YYYY")}
            </Text> */}
            {state?.status === "draft" && !hasEnded && (
              <div className={classes.draft}>
                <p>Draft</p>
              </div>
            )}
            {hasEnded && (
              <div className={classes.completed}>
                <p>Completed</p>
              </div>
            )}
            {state?.status === "expired" && (
              <div className={classes.expired}>
                <p>Expired</p>
              </div>
            )}
            {staffSignature?.signature || staffSignature?.signatureImage ? (
              <Flex justify="flex-end">
                <img
                  src={
                    decrypt(staffSignature?.signature) ||
                    decrypt(staffSignature?.signatureImage)
                  }
                  alt="signature"
                  className={classes.signatureImg}
                />
              </Flex>
            ) : staffSignature?.signatureText ? (
              <Text fz={32} fw={400} ff="Island Moments" color="var(--app-text)">
                {staffSignature?.signatureText}
              </Text>
            ) : null}
          </div>
          <SimpleGrid
            cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}
            className={classes.divGap}
          >
            <div className={classes.detail}>
              <Select
                label="Staff Name"
                radius={"md"}
                placeholder={state?.selectedShift?.staff?.name}
                disabled={true}
                data={[]}
              />
            </div>
            <div className={classes.info}>
              <Select
                label="Client Name"
                radius={"md"}
                value={state?.client?.id}
                placeholder={
                  state?.client ? decrypt(state?.client?.name, false) : "Client"
                }
                disabled={true}
                data={
                  allPatients
                    ?.filter(
                      (_p) => _p?.active === true && _p?.deleted === false,
                    )
                    ?.map((data) => {
                      return {
                        value: data?.id,
                        label: data?.name,
                      };
                    }) || []
                }
                // {...form.getInputProps("client")}
              />
            </div>
            <div className={classes.info}>
              <Select
                label="Facitlity"
                radius={"md"}
                placeholder={state?.facility?.name}
                disabled={true}
                data={
                  allFacilities?.facilities?.map((data) => {
                    return {
                      value: data?.id,
                      label: data?.name,
                    };
                  }) || []
                }
                //   {...form.getInputProps("facility")}
              />
            </div>
            {isIndividualizedSkillsType ? (
              <div className={classes.detail}>
                <TextInput
                  label="License Number"
                  radius="md"
                  placeholder="Add License Number"
                  value={state?.providerLicense || ""}
                  disabled
                />
              </div>
            ) : (
              <div className={classes.info}>
                <Select
                  label="Shift"
                  radius={"md"}
                  placeholder={state?.selectedShift?.name}
                  // placeholder={state?.shift?.[state?.shift?.length - 1]?.name}
                  disabled={true}
                  data={["Morning", "Evening", "Night"]}
                  //   {...form.getInputProps("shift")}
                />
              </div>
            )}
          </SimpleGrid>
          <SimpleGrid>
            {isIndividualizedSkillsType && (
              <>
                <Grid>
                  {/* Place of Service - 50% width */}
                  <Grid.Col
                    span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 6}
                  >
                    <TextInput
                      label="Place of Service"
                      value={state?.placeOfService || ""}
                      disabled
                      radius="md"
                    />
                  </Grid.Col>

                  {/* State - 25% width */}
                  <Grid.Col
                    span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 3}
                  >
                    <TextInput
                      label="State"
                      value={state?.state || ""}
                      disabled
                      radius="md"
                      variant="default"
                    />
                  </Grid.Col>

                  {/* Zip Code - 25% width */}
                  <Grid.Col
                    span={isMoobileScreen ? 12 : isTabletScreen ? 6 : 3}
                  >
                    <TextInput
                      label="Zip Code"
                      value={state?.zipcode || ""}
                      disabled
                      radius="md"
                    />
                  </Grid.Col>
                </Grid>
                <SimpleGrid cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}>
                  <div className={classes.detail}>
                    <TextInput
                      label="Site"
                      value={state?.site || ""}
                      disabled
                      radius="md"
                    />
                  </div>
                  <div className={classes.detail}>
                    <TextInput
                      label="Date"
                      value={moment(state?.dateTime).format("MM/DD/YYYY") || ""}
                      disabled
                      radius="md"
                    />
                  </div>
                  <div className={classes.info}>
                    <Select
                      label="Shift"
                      radius={"md"}
                      placeholder={state?.selectedShift?.name}
                      value={state?.selectedShift?.name}
                      // placeholder={state?.shift?.[state?.shift?.length - 1]?.name}
                      disabled={true}
                      data={["Morning", "Evening", "Night"]}
                      //   {...form.getInputProps("shift")}
                    />
                  </div>
                  <div className={classes.info}>
                    <Select
                      id="level-of-care"
                      searchable
                      label="Level of Need"
                      data={levelOfNeedOptions}
                      radius={"md"}
                      disabled={true}
                      value={state?.levelofneed || ""}
                      placeholder="Select Level of Need"
                    />
                  </div>
                </SimpleGrid>
                <SimpleGrid cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 4}>
                  <TimeInput
                    label="Time In"
                    format="12"
                    // className={classes.datePicker}
                    icon={
                      <img
                        style={{ width: "20px" }}
                        src={"/assets/images/clock.png"}
                        alt="Icon"
                      />
                    }
                    value={state.timeIn || ""}
                    disabled={true}
                    radius={"md"}
                  />
                  <TimeInput
                    label="Time Out"
                    format="12"
                    // className={classes.datePicker}
                    icon={
                      <img
                        style={{ width: "20px" }}
                        src={"/assets/images/clock.png"}
                        alt="Icon"
                      />
                    }
                    value={state.timeOut || ""}
                    disabled={true}
                    radius={"md"}
                  />
                </SimpleGrid>
              </>
            )}
          </SimpleGrid>
          <Flex gap={20} align={"center"} mt={10} wrap={"wrap"}>
            <Box className={classes.detail}>
              <p>
                <strong>Date Created: </strong>{" "}
                {state?.dateTime &&
                  moment(
                    state?.dateTime ? state?.dateTime : state?.createdAt,
                  ).format("MM-DD-YYYY")}{" "}
                at{" "}
                {state?.dateTime
                  ? moment(state?.dateTime).format("hh:mm a")
                  : "-"}
              </p>
            </Box>
            {profile?.user?.role !== "staff" && <Box className={classes.detail}>
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <strong>Time Remaining: </strong>{" "}
                {state?.dateTime &&
                state?.taskEndAt &&
                state?.status !== "completed" ? (
                  <AuctionTimer />
                ) : (
                  "Task Ended"
                )}
              </p>
            </Box>}
          </Flex>
        </Box>

        {/* OD-888: ADL Matrix snapshot table */}
        {state?.adlMatrixSnapshot && state.adlMatrixSnapshot.length > 0 && (
          <ViewAdlTable snapshot={state.adlMatrixSnapshot} taskDate={state?.createdAt || state?.taskStartAt} />
        )}

        <div>
          <h3>Task List</h3>
        </div>
        <Box className={`${classes.mainContainer} ${classes.checkBoxParent}`}>
          <SimpleGrid
            className={classes.checkBoxContainer}
            cols={isMoobileScreen ? 1 : isTabletScreen ? 2 : 3}
          >
            {state?.taskType?.subTasks
              ?.filter((task) => {
                if (task?.task?.name === isCommunityIntegration) {
                  return state.site === "Off-Site";
                }
                  if (task?.task?.name === "Body Care" && activePlan)
                          return false;
                if (
                  state?.taskType?.name === "Activities of Daily Living" &&
                  !activePlan &&
                  (task?.task?.name === "Hygiene" ||
                    task?.task?.name === "Nutrition and Hydration")
                ) {
                  return false;
                }

                // If activePlan has fieldsDone, only show subtasks that have matching fields
                // if (
                //   activePlan?.activitiesOfDailyLiving?.fieldsDone?.length > 0
                // ) {
                //   // const planFieldIds =
                //   //   activePlan.activitiesOfDailyLiving.fieldsDone.map(
                //   //     (fd) => fd.field,
                //   //   );

                //   const planFieldIds = state.fieldsDone.map(
                //     (fd) => fd.field._id,
                //   );

                //   // Check if any field in this subtask matches the plan's fields
                //   const hasMatchingField = task?.fields?.some((field) =>
                //     planFieldIds.includes(field._id),
                //   );

                //   return hasMatchingField;
                // }
                return true;
              })
              ?.map((tasks) => {
                const subTaskName = tasks?.task?.name;
                const shouldHideFields =
                  state?.taskType?.name === "Activities of Daily Living" &&
                  !activePlan;

                let filteredFields = shouldHideFields
                  ? tasks?.fields?.filter(
                      (field) =>
                        !taskAdlHiddenFields[subTaskName]?.includes(
                          field?.name,
                        ),
                    ) || []
                  : tasks?.fields || [];

                // if (
                //   activePlan?.activitiesOfDailyLiving?.fieldsDone?.length > 0
                // ) {
                //   const planFieldIds =
                //     state.fieldsDone?.map((fd) => String(fd.field._id)) || [];

                //   filteredFields = (tasks?.fields || []).filter((field) =>
                //     planFieldIds.includes(String(field._id)),
                //   );
                // }

                return (
                  <div>
                    <AccordionCheck
                      type={"view"}
                      Data={filteredFields}
                      checksDone={state?.fieldsDone || []}
                      Heading={tasks?.task?.name}
                      setChecks={setChecks}
                      checks={checks}
                      userType={userType}
                      userId={profile?.user?.id}
                      viewOnly={true}
                    />
                  </div>
                );
              })}
          </SimpleGrid>
          <Flex className={classes.commentFlex} justify="flex-end">
            <Indicator label={comments?.length} color="red" size={20}>
              <Button
                w={200}
                size="lg"
                radius={"md"}
                onClick={open}
                variant="light"
                className={classes.commentBtnStyle}
              >
                + Comments
              </Button>
            </Indicator>
          </Flex>
        </Box>

        <CommentDrawer
          title={"Comments"}
          opened={opened}
          close={close}
          comments={comments}
          setComments={setComments}
          data={profile}
          view={true}
        />
        {/* <Box className={classes.mainContainer}>
          <div>
            <h3>Additional Notes</h3>
            <div className={classes.divGap}>
              <Textarea
                defaultValue={
                  state?.notes?.find(
                    (obj) =>
                      obj?.staff?.id === state?.selectedShift?.staff?.id &&
                      obj.shift === state?.selectedShift?.name
                  )?.note || "-"
                }
                // defaultValue={state?.notes}
                disabled={true}
                minRows={4}
                style={{ height: "auto" }}
              />
            </div>
          </div>
        </Box>

        <Box className={classes.mainContainer}>
          <h3>Previous Notes</h3>
          <div className={classes.divGap}>
            <PreviousNotesComp notes={state?.notes} />
          </div>
        </Box> */}
      </Box>
    </Container>
  );
};

// OD-888: ADL Matrix table for completed task view
const ADL_VIEW_DAY_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const ADL_VIEW_DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const ViewAdlTable = ({ snapshot, taskDate }) => {
  const todayIdx = new Date(taskDate || Date.now()).getDay();

  return (
    <Box mb={16} p="md" style={{ background: "#FAF6EE", borderRadius: 12 }}>
      <Flex justify="space-between" align="center" mb={8}>
        <Text fw={600} size="xs" color="dimmed" tt="uppercase">
          ADL SUMMARY — {["SUNDAY","MONDAY","TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY"][todayIdx]}
        </Text>
        <Badge color="teal" variant="outline" size="sm">ADL ON FILE</Badge>
      </Flex>

      <Box style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, fontFamily: "Inter, sans-serif" }}>
          <thead>
            <tr style={{ background: "#F5F0E8" }}>
              <th style={{ textAlign: "left", padding: "6px 8px", fontWeight: 600, borderBottom: "2px solid #E0D9CC" }}>
                ADL Category
              </th>
              {ADL_VIEW_DAY_LABELS.map((label, i) => (
                <th
                  key={label}
                  style={{
                    textAlign: "center",
                    padding: "6px 4px",
                    fontWeight: 600,
                    borderBottom: "2px solid #E0D9CC",
                    minWidth: 36,
                    background: i === todayIdx ? "#FEF3C7" : undefined,
                  }}
                >
                  {label}
                </th>
              ))}
              <th style={{ textAlign: "center", padding: "6px 8px", fontWeight: 600, borderBottom: "2px solid #E0D9CC" }}>
                Code
              </th>
            </tr>
          </thead>
          <tbody>
            {snapshot.map((act, rowIdx) => (
              <tr key={rowIdx} style={{ background: rowIdx % 2 === 0 ? "#FAFAF5" : "#FFF" }}>
                <td style={{ padding: "6px 8px", fontWeight: 500, borderBottom: "1px solid #EEE" }}>
                  {(act.activity || "").toUpperCase()}
                </td>
                {ADL_VIEW_DAY_KEYS.map((dk, i) => (
                  <td
                    key={dk}
                    style={{
                      textAlign: "center",
                      padding: "6px 4px",
                      borderBottom: "1px solid #EEE",
                      fontWeight: 500,
                      background: i === todayIdx ? "#FEF3C7" : undefined,
                    }}
                  >
                    {act.days?.[dk] ? "X" : ""}
                  </td>
                ))}
                <td style={{ textAlign: "center", padding: "6px 8px", fontWeight: 600, borderBottom: "1px solid #EEE" }}>
                  {act.code ?? 0}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};

export default ViewTask;
